export const visualizationConfig = {
  pixelLayers: [
    {
      label: "Terra Areas",
      legend: {
        color: "#5f9b1c",
        shape: "square",
      },
    },
    {
      label: "Planitia Areas",
      legend: {
        color: "#7f4883",
        shape: "square",
      },
    },
    {
      label: "Planum Areas",
      legend: {
        color: "#f76707",
        shape: "square",
      },
    },
    {
      label: "Chaos and Channels",
      legend: {
        color: "#84acba",
        shape: "square",
      },
    },
    {
      label: "Mountains",
      legend: {
        color: "#d04433",
        shape: "square",
      },
    },
  ],
  pointLayers: [
    {
      label: "Mountains",
      legend: {
        color: "#f5d742",
        shape: "circle",
      },
    },
    {
      label: "Mission Sites",
      legend: {
        color: "#42f5d7",
        shape: "circle",
      },
    },
  ],
};
